import React from "react";
import { Stack } from "@origin-digital/ods-core";
import { Head } from "../../components/Head/Head";
import { IMetadata } from "../../interface/metadata";

interface IPageTemplateProps {
  "data-id"?: string;
  metadata?: IMetadata;
  children: React.ReactNode;
}

export const PageTemplate = ({
  "data-id": dataId,
  metadata,
  children,
}: IPageTemplateProps) => {
  return (
    <Stack data-id={dataId} space="none">
      <Head metadata={metadata} />
      <div />
      {children}
      <div />
    </Stack>
  );
};
